import { gql, useMutation } from "@apollo/client";
import { MutationCreateDesignerApplicationArgs } from "../../__generated__/types";

const CREATE_MEMBERSHIP_APPLICATION_MUTATION = gql`
  mutation CreateDesignerApplication(
    $designerId: ID!
    $experience: [ApplicationExperience]
  ) {
    createDesignerApplication(designerId: $designerId, experience: $experience)
  }
`;

// Normalize enum fields: convert empty strings to null/undefined before sending to GraphQL
const normalizeExperienceEnumFields = (experience: any[]): any[] => {
  if (!experience || !Array.isArray(experience)) {
    return experience;
  }
  return experience.map((exp: any) => {
    const normalized: any = { ...exp };
    if (normalized.employmentType === '') {
      normalized.employmentType = null;
    }
    if (normalized.firmSize === '') {
      normalized.firmSize = null;
    }
    return normalized;
  });
};

export const useCreateMembershipApplicationMutation = () => {
  const [createApplicationMutation, { loading, error }] = useMutation(
    CREATE_MEMBERSHIP_APPLICATION_MUTATION
  );

  const createApplication = async (
    args: MutationCreateDesignerApplicationArgs
  ) => {
    try {
      // Normalize enum fields before sending to GraphQL
      const normalizedArgs = {
        ...args,
        experience: normalizeExperienceEnumFields(args.experience || []),
      };
      
      const result = await createApplicationMutation({
        variables: normalizedArgs,
      });
      return result?.data?.createDesignerApplication;
    } catch (err) {
      console.error("Error creating application:", err);
      throw err;
    }
  };

  return { createApplication, loading, error };
};
